import React from 'react';

import { TechemTheme } from '@techem/techem-theme';
import { useStyletron } from 'styletron-react';

import { ModalFooter } from 'baseui/modal';

const CustomModalFooter: React.FC<any> = ({ children }) => {
  const [css] = useStyletron();
  return (
    <ModalFooter
      className={css({
        padding: '24px !important',
        marginRight: '0px !important',
        marginLeft: '0px !important',
        backgroundColor: TechemTheme.colors.backgroundSecondary,
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        '@media (max-width: 767px)': {
          paddingBottom: '48px !important'
        }
      })}
    >
      {children}
    </ModalFooter>
  );
};

export default CustomModalFooter;
